export default "__VITE_ASSET__DYPT_8_s__"